/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { putRequest } from "utils/request";

import { postRequest } from "utils/request";

import { i18n } from "../../../../translate/i18n";

export default function NewStatus({
  selectedstatus,
  handleNewStatus,
  companyId,
  handleGoBack,
}) {
  const [descInterna, setDescInterna] = useState("");
  const [descExterna, setDescExterna] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const [liststatus, setListStatus] = useState([
    { id: 1, description: "Em Aberto" },
    { id: 2, description: "Aguardando Cliente" },
    { id: 3, description: "Em Atendimento" },
    { id: 4, description: "Concluído" },
  ]);

  useEffect(() => {
    setLoading(true);

    if (JSON.stringify(selectedstatus) === "{}") {
      setListStatus(liststatus.filter((element) => element.id !== 1));
    }

    setDescInterna(selectedstatus.internalDescription);
    setDescExterna(selectedstatus.externalDescription);
    setStatus(selectedstatus.statusUser);

    setLoading(false);
  }, []);

  const handleSendStatus = () => {
    setLoading(true);

    if (selectedstatus.id) {
      putRequest(`/companiesstatus/${selectedstatus.id}`, {
        CompanyId: companyId,
        internalDescription: descInterna,
        externalDescription: descExterna,
        statusUser: status,
        onlyUser: 0,
      }).then(function (response) {
        setLoading(false);
        if (response.success) {
          handleNewStatus();
        }
      });
    } else {
      postRequest(`/companiesstatus`, {
        CompanyId: companyId,
        internalDescription: descInterna,
        externalDescription: descExterna,
        statusUser: status,
        onlyUser: 0,
      }).then(function (response) {
        setLoading(false);
        if (response.success) {
          handleNewStatus();
        }
      });
    }
  };

  return (
    <>
      {!loading ? (
        <form
          style={{ width: "70vw", height: "60vh" }}
          className="form-edit"
          onSubmit={(e) => {
            e.preventDefault();
            handleSendStatus();
          }}
        >
          <div className="container-area-new-status">
            <div className="row">
              <div className="col-lg">
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label className="col-form-label">
                      {i18n.t("status")} *
                    </label>
                    <select
                      className="form-control select2"
                      data-toggle="select2"
                      value={status}
                      disabled={selectedstatus.id}
                      required
                      onChange={(value) => setStatus(value.target.value)}
                    >
                      <option value="">{i18n.t("select")}</option>
                      {liststatus.map((data, index) => (
                        <option key={index} value={data.id}>
                          {data.description}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg">
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label className="col-form-label">
                      {i18n.t("externalDescription")} *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      maxLength={100}
                      required
                      value={descExterna}
                      onChange={(value) => setDescExterna(value.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg">
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label className="col-form-label">
                      {i18n.t("internalDescription")} *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      maxLength={100}
                      required
                      value={descInterna}
                      onChange={(value) => setDescInterna(value.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="button-list mt-3 pull-right"
              style={{ position: "absolute", bottom: 0, right: 0 }}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => handleGoBack()}
              >
                <i i className="mdi mdi-backup-restore"></i>
                {i18n.t("getBack")}
              </button>
              <button type="submit" className="btn btn-outline-success">
                <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                {i18n.t("save")}
              </button>
            </div>
          </div>
        </form>
      ) : (
        <div className="area-loading">
          <CircularProgress />
        </div>
      )}
    </>
  );
}
